import { z } from 'zod'

// a forecast (not announced) dividend for a held stock, projected from the last 3 years of
// declared dividend history. rendered as the distinct "projected" segment of the income chart and
// listed (with a remove action) below the upcoming payments. coupons are out of scope — projections
// are dividends only.
export const projectedDividendResponseSchema = z.object({
  id: z.string().guid(),
  instrumentUid: z.string(),
  figi: z.string().nullable(),
  ticker: z.string().nullable(),
  instrumentName: z.string().nullable(),
  // lowercase T-Bank instrument kind ('share' | 'bond' | 'etf') from the local instrument cache;
  // optional, since the cache is filled lazily and older cached responses omit it
  instrumentType: z.string().nullable().optional(),
  // predicted representative payout date (UTC noon to keep the month stable across timezones)
  paymentDate: z.coerce.date(),
  // last actual declared per-share for the recurring payout slot
  amountPerUnit: z.number(),
  currency: z.string().nullable(),
  // current holdings the projection was computed against
  quantity: z.number(),
  // amountPerUnit × quantity, in the instrument currency (the chart converts to RUB)
  expectedAmount: z.number(),
})

export type ProjectedDividendResponseDto = z.infer<typeof projectedDividendResponseSchema>
